import { DollarSign, Banknote, CreditCard } from "lucide-react";

interface FinancialSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  isDispacer: boolean;
  isEditMode: boolean;
}

const FinancialSection: React.FC<FinancialSectionProps> = ({
  formData,
  setFormData,
  isDispacer,
  isEditMode
}) => {
  // Nu afișa secțiunea financiară dacă este dispacer ÎN modul de editare
  if (isDispacer && isEditMode) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl p-4 border border-emerald-200 shadow-sm">
      <div className="flex items-center mb-3">
        <div className="p-2 bg-emerald-500 rounded-lg mr-3">
          <DollarSign className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Financiar</h3>
      </div>

      <div className="space-y-3">
        {/* Valoare */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Valoare (RON) *
          </label>
          <input
            type="number"
            step="0.01"
            min="0"
            value={formData.value || ""}
            onChange={(e) =>
              setFormData(prev => ({ 
                ...prev, 
                value: parseFloat(e.target.value) || 0 
              }))
            }
            className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            placeholder="0.00"
            required
          />
        </div>

        {/* Tip plată */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Tip plată *
          </label>
          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() => setFormData(prev => ({ ...prev, tip_plata: "cash" }))}
              className={`p-2 rounded border transition-all flex items-center justify-center text-sm ${
                formData.tip_plata === "cash" 
                  ? "border-emerald-500 bg-emerald-100 text-emerald-700" 
                  : "border-gray-300 hover:border-gray-400 text-gray-600"
              }`}
            >
              <Banknote className="w-4 h-4 mr-1" />
              Cash
            </button>
            <button
              type="button"
              onClick={() => setFormData(prev => ({ ...prev, tip_plata: "card" }))}
              className={`p-2 rounded border transition-all flex items-center justify-center text-sm ${
                formData.tip_plata === "card" 
                  ? "border-blue-500 bg-blue-100 text-blue-700" 
                  : "border-gray-300 hover:border-gray-400 text-gray-600"
              }`}
            >
              <CreditCard className="w-4 h-4 mr-1" />
              Card
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialSection;